// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/mulligan.scss
 ** module id = 982
 ** module chunks = 0
 **/